import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { initSentry, Sentry } from './services/sentry';
import './index.css';

// Sentry must init before React so it can hook console + fetch globally.
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<AppCrash />} showDialog={false}>
      <BrowserRouter>
        <AuthProvider>
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              style: { borderRadius: '12px', background: '#0f172a', color: '#fff' },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

/**
 * Last-line-of-defense UI when a render throws. We keep this lean so it works
 * even if Tailwind/CSS failed to load. The Sentry boundary has already captured
 * the error by the time this renders.
 */
function AppCrash() {
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'system-ui', padding: 24 }}>
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <h1 style={{ fontSize: 22, margin: 0 }}>Something went wrong</h1>
        <p style={{ color: '#64748b', marginTop: 8 }}>
          We've been notified and will fix it. Try reloading — if it keeps happening, email support@gradelab.club.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{ marginTop: 16, padding: '10px 18px', borderRadius: 10, border: 0, background: '#6366f1', color: '#fff', cursor: 'pointer' }}
        >
          Reload
        </button>
      </div>
    </div>
  );
}
